import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApproveIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			transform: "translate(0 0.0234375)",
			fill: "white",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8.02344,
			r: 7.5,
			fill: "#36B933"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4062 5.67383L6.45624 10.6233L4.46629 8.63336",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgApproveIcon);
export default ForwardRef;
